import * as types from '../mutation-types'

import Vapi from 'vuex-rest-api'
import merge from 'lodash/merge'
import Vue from 'vue'

const module = new Vapi({
  baseURL: Vue.$backendBaseURL,
  state: {
    all: [],
    current: {}
  }
})
.get({
  action: 'listSubscriberDb',
  property: 'all',
  path: ({ orgId }) => `/orgs/${orgId}/subscriber_db`
})
.get({
  action: 'getSubscriberDb',
  property: 'current',
  path: ({ orgId, id }) => `/orgs/${orgId}/subscriber_db/${id}`
})
.post({
  action: 'createSubscriberDb',
  property: 'current',
  path: ({ orgId }) => `/orgs/${orgId}/subscriber_db`
})
.put({
  action: 'updateSubscriberDb',
  property: 'current',
  path: ({ orgId, id }) => `/orgs/${orgId}/subscriber_db/${id}`
})
.getStore()

const state = {
}

const getters = {
}

const actions = {
}

const mutations = {
  [types.RESET_SDB_STATE] (state) {
    state.all = []
    state.current = null
    state.pending = {
      all: false,
      current: false
    }
    state.error = {
      all: null,
      current: null
    }
  }
}

export default merge(module, {
  state,
  getters,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/modules/subscriber-db.js